// @core/api/endpoints/legalentity/change_legal_entity_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChangeLegalEntityStatusRequest,
  LegalEntityResponse,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Change legal entity status
 * Transitions the legal entity through its lifecycle. Allowed transitions are enforced server-side. Liquidated entities become read-only but remain visible for historical contracts.
 */
export async function ChangeLegalEntityStatus(
  legal_entity_id: string,
  data: ChangeLegalEntityStatusRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id/status`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.post<LegalEntityResponse>(requestPath, data, requestOptions);
}
